import React from "react";

export  function CurrencyFormat(Number: number) {
	return (
		Intl.NumberFormat('en-US',{
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 0,
			maximumFractionDigits: 2,
			}).format(Number));
}

export  function LongNumberFormat(Number: number) {
	return (
		Intl.NumberFormat('en-US',{
			minimumFractionDigits: 0,
			maximumFractionDigits: 2,
			}).format(Number));
}